// Formato del payload que se codifica en el QR personal del Punto Limpio, generado al
// confirmar una visita (incluye los campos de empresa si tipo_solicitante=empresa). El QR
// generado por el backend en POST /api/puntolimpio/generar-mi-qr (solo ciudadanos, de momento)
// usa un subconjunto de estos mismos campos.
export const QR_FIELDS = [
  "tipo_solicitante", "nombre_apellidos", "dni_nie", "razon_social", "cif",
  "codigopostal", "direccion", "numero", "piso", "letra", "email",
];

export function buildQrPayload(data) {
  const out = { tipo: "puntolimpio_ciudadano_v1" };
  QR_FIELDS.forEach((f) => { out[f] = data[f] ?? ""; });
  return JSON.stringify(out);
}
